// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.9%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
*/

/*  --medium-blue: #00c9ff; */
:root {
  --light-blue: #d9f4ff;
  --light-blue-hover: #bbeffd;
  --medium-blue: #0069d9;
  --nav-blue: #2598c5;
  --nav-green: #16a085;
  --nav-cyan: #02bdde;
  --font-black: #282c34;
  --updated-purple: #e6deff;
  --updated-purple-hover: #d5d1ff;
  --light-yellow: #ffffcc;
  --light-grey-hover: #ced4da;
  --light-grey: #e9ecef;
  --light-red: #ffebeb;
  --light-red-hover: #ffcccb;
  --medium-red: #ff0500;
}


.App {
  text-align: center;
}

.App-testing-prod {
  /* background color for prod when testing */
  background-color: red;
  /* background-color: #ffcccb; light red */
}
.App-testing-dev {
  /* background color for not-prod when testing */
  background-color: #f7f6af;   /* light yellow */
  /* background-color: #fdf88d;  yellow */
  /* background: repeating-linear-gradient(-45deg, #fdf88d, #fdf88d 10px, #e9e485 10px, #e9e485 20px);  diagonal yellow dark warning */
}

.Alliance-logo {
  height: 50px;
  pointer-events: none;
}

.Navbar {
  background-color: var(--nav-blue);
  color: white;
}

.Navbar-stage {
  background-color: var(--nav-green);
  color: white;
}

.Navbar-dev {
  background-color: var(--nav-cyan);
  color: white;
}

/* Custom navbar expand behavior at 1400px */
.navbar-custom-expand .navbar-toggler {
  display: flex;
}

/* Close button row for mobile sidebar */
.navbar-close-row {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  margin-bottom: 0.5rem;
}

.navbar-close-btn {
  background: none;
  border: none;
  color: white;
  font-size: 1.25rem;
  cursor: pointer;
  padding: 0.5rem;
  margin-right: 0.5rem;
}

.navbar-close-btn:hover {
  opacity: 0.7;
}

/* Mobile only elements (< 1400px) */
.navbar-mobile-only {
  display: flex;
}

/* Desktop only elements (>= 1400px) */
.navbar-desktop-only {
  display: none;
}

@media (min-width: 1400px) {
  .navbar-custom-expand .navbar-toggler {
    display: none;
  }

  .navbar-custom-expand .navbar-collapse {
    display: flex !important;
    flex-direction: row !important;
  }

  .navbar-custom-expand .navbar-main-links,
  .navbar-custom-expand .navbar-right-links {
    flex-direction: row !important;
  }

  .navbar-mobile-only {
    display: none !important;
  }

  .navbar-desktop-only {
    display: block !important;
  }
}

/* Prevent navbar from wrapping - keep items in one row (desktop only) */
@media (min-width: 1400px) {
  .Navbar .navbar-collapse,
  .Navbar-stage .navbar-collapse,
  .Navbar-dev .navbar-collapse {
    flex-wrap: nowrap;
  }

  .Navbar .navbar-collapse .nav,
  .Navbar-stage .navbar-collapse .nav,
  .Navbar-dev .navbar-collapse .nav {
    flex-wrap: nowrap;
  }
}

/* Sidebar style for collapsed navbar on smaller screens */
@media (max-width: 1399.98px) {
  /* Base styles for the collapse - hidden by default */
  .navbar-custom-expand .navbar-collapse {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: 280px;
    max-width: 80vw;
    background-color: inherit;
    flex-direction: column !important;
    align-items: flex-start;
    padding: 1rem;
    overflow-y: auto;
    z-index: 1050;
  }

  /* When collapsed (not showing), hide it */
  .navbar-custom-expand .navbar-collapse:not(.show) {
    display: none !important;
  }

  /* When expanded (showing), display as flex sidebar */
  .navbar-custom-expand .navbar-collapse.show {
    display: flex !important;
    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.3);
  }

  .navbar-custom-expand .navbar-collapse .nav,
  .navbar-custom-expand .navbar-main-links,
  .navbar-custom-expand .navbar-right-links {
    flex-direction: column !important;
    width: 100% !important;
    margin: 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    align-items: stretch !important;
    justify-content: flex-start !important;
  }

  .navbar-custom-expand .navbar-collapse .nav.mx-auto {
    margin: 0 !important;
  }

  .navbar-custom-expand .navbar-right-links {
    margin-top: 0.5rem;
    padding-top: 0.5rem;
    border-top: 1px solid rgba(255, 255, 255, 0.3);
  }

  .navbar-custom-expand .navbar-collapse .nav-link,
  .navbar-custom-expand .navbar-collapse .navbar_link {
    padding: 0.75rem 1rem !important;
    margin-left: 0 !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    text-align: left !important;
    width: 100%;
    display: block;
  }

  /* Ensure dropdown menus are visible in sidebar */
  .navbar-custom-expand .navbar-collapse .dropdown-menu {
    position: static !important;
    float: none;
    background-color: rgba(255, 255, 255, 0.1);
    border: none;
    margin: 0;
    padding: 0;
  }

  .navbar-custom-expand .navbar-collapse .dropdown-item {
    color: white;
    padding: 0.5rem 1rem;
  }

  .navbar-custom-expand .navbar-collapse .dropdown-item:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }

  .navbar-custom-expand .navbar-toggler {
    border-color: rgba(255, 255, 255, 0.5);
  }

  .navbar-custom-expand .navbar-toggler-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }
}

#login-nav-dropdown {
  font-family: 'Roboto', sans-serif;
  color: white !important;
  margin-left: 20px;
}

#tester-nav-dropdown {
  font-family: 'Roboto', sans-serif;
  color: white !important;
  margin-left: 20px;
}

#devtools-nav-dropdown {
  font-family: 'Roboto', sans-serif;
  color: white !important;
  margin-left: 20px;
}

.navbar_link {
  font-family: 'Roboto', sans-serif;
  color: white !important;
  margin-left: 20px;
}

/* Override navbar_link margin on mobile sidebar */
@media (max-width: 1399.98px) {
  .navbar_link {
    margin-left: 0 !important;
    padding-left: 1rem !important;
    text-align: left !important;
  }
}

.NotLoggedInAlert-everLogged {
  position: sticky !important;
  top: 0 !important;
  left: 0px;
  width: 100%;
  z-index: 998;
  margin-bottom: 0 !important;
}

.button-to-link {
  background: none!important;
  border: none;
  padding: 0!important;
  font-family: arial, sans-serif;
  color: #007bff;
  cursor: pointer;
}

.button-to-link:hover {
  color: #069;
  text-decoration: underline;
}

.affiliation {
  font-size: 14px;
  color: grey;
}

.row-even {
  padding-bottom: 1rem;
  margin-bottom: 0 !important;
  background-color: var(--light-yellow) !important;
}
.row-odd {
  padding-bottom: 1rem;
  margin-bottom: 0 !important;
  background-color: white !important;
}

.div-grey-border {
  border: 1px solid var(--light-grey-hover);
  border-radius: .25rem;
  min-height: 2.3rem;
  padding: .35rem;
}

.div-merge {
  border-radius: .25rem;
  overflow: hidden;
  padding: .35rem;
  margin: .35rem;
}

.div-merge-grey {
  border: 1px solid var(--light-grey-hover);
  background-color: var(--light-grey) !important;
}

/*
.div-merge-stripes {
  background: repeating-linear-gradient(
    45deg,
    transparent,
    transparent 10px,
    var(--light-grey) 10px,
    var(--light-grey) 20px
  );
}
*/

.div-merge-keep {
  border: 1px solid var(--light-blue-hover);
  background-color: var(--light-blue) !important;
}

.div-merge-obsolete {
  border: 1px solid var(--light-red-hover);
  background-color: var(--light-red) !important;
}

.span-merge-header-success {
  font-size: 1.2em;
  color: var(--medium-blue) !important;
}

.span-merge-header-failure {
  font-size: 1.2em;
  color: var(--medium-red) !important;
}

.span-merge-message-init {
  color: 'black';
}

.span-merge-message-success {
  color: var(--medium-blue) !important;
}

.span-merge-message-failure {
  color: var(--medium-red) !important;
}

.biblio-updating {
  text-align: center;
  background-color: var(--light-grey) !important;
}

.sort-status-alert {
  margin-bottom: 0;
}

.biblio-button:hover {
  background-color: var(--light-blue-hover) !important;
  filter: drop-shadow(2px 2px 1px #aaaaaa);
}
.biblio-button {
  text-align: center;
  background-color: var(--light-blue) !important;
  border-radius: 5px !important;
  filter: drop-shadow(3px 3px 1px #aaaaaa);
}
/*
  background-color: #ffffba !important;
  font-weight: 600 !important;
  font-weight: bold !important;
  border-color: white !important;
  box-shadow:
    0 0 0 3px white,
    0 0 0 8px #ffffba;
  border-color: #2598c5 !important;
  background-color: var(--light-grey) !important;
  display: block;
  width: 100%;
  padding-left: .75rem;
  padding-right: .75rem;
  color: #282c34;
  line-height: 1.5;
  border: 1px solid #2598c5;
  border-radius: .25rem;
  height: calc(1.5em + .75rem + 2px);
  padding-top: .375rem;
  padding-bottom: .375rem;
*/

.task {
  background: #f4f4f4;
  margin: 5px;
  padding: 10px 20px;
  cursor: pointer;
  padding-left: 40px;
}

/*  border-radius: 30px 0 0 30px; */

.task.reminder {
  border-left: 5px solid green;
}

.Col-display {
  background-color: var(--light-blue);
}

.Col-display-warn {
  background-color: var(--light-red);
}

.Col-display-grey {
  background-color: var(--light-grey);
}

.updated-biblio-button:hover {
  background-color: var(--updated-purple-hover) !important;
}
.updated-biblio-button {
  background-color: var(--updated-purple) !important;
}
.updated {
  background-color: var(--updated-purple) !important;
}

.underlined {
  border-bottom: 4px solid var(--light-blue-hover);
}

.radio-form {
  margin: 4px 4px 4px 4px;
  padding: 2px 2px 4px 2px;
}
.radio-span {
  display: inline-block;
  margin: 4px 4px 4px 4px;
  padding: 2px 0px 4px 2px;
}

/* Mode-selector row: use the full viewport width so all options sit on one
   line on wide monitors (wrapping only when genuinely narrow), instead of
   being capped by the Bootstrap container and wrapping early. Full-bleed via
   negative margins keeps it centered without a hard-coded width.
   100vw includes the vertical scrollbar's width while the containing block
   does not, so on classic (non-overlay) scrollbars the full-bleed row is
   ~15px wider than the viewport; the body-level overflow-x: clip below
   swallows that instead of growing a page-wide horizontal scrollbar. */
.biblio-mode-radios {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  width: auto;
  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);
  padding-left: 12px;
  padding-right: 12px;
}

/* Clip (not hide) page-level horizontal overflow: every horizontally wide
   element in this app scrolls inside its own container, so overflow past the
   body is only ever the 100vw-vs-scrollbar artifact above. \`clip\` does not
   create a scroll container, so position: sticky keeps working. */
body {
  overflow-x: clip;
}

.radio-span:hover {
  background-color: var(--light-blue);
  border-radius: 10px;
  opacity: 0.9;
}
/* opacity: 90%;  proper react build production does not like this
   https://stackoverflow.com/questions/58853844/the-opacity-value-was-changed-to-1-after-building-the-reacjs-project */

.Col-editor-disabled {
  background-color: #e9ecef;
}

.Col-checkbox {
  display: flex;
  align-items : center;
  padding: 0 !important;
}

.ColEditorCheckbox input {
  height: 20px;
  width: 20px;
}

.Col-editor-buttons {
  display: flex;
}

.Col-general {
  text-align: left;
  display: flex;
  align-items : center;
  color: var(--font-black);
  border: 2px solid white;
  padding: 5px 10px;
}
/*
  background-color: #f4f4f4;
  border: 1px solid #bbbbbb;
  border: 1px solid #61dafb;
*/
.Col-display-right {
  border-radius: 0 30px 30px 0;
}
.Col-display-left {
  border-radius: 30px 0 0 30px;
}
.Col-search {
  display: block;
}
.searchRow-title{
  font-size: 1.4em;
}
.searchRow-xref{
  padding-block: 10px;
}
.searchRow-other{
  line-height: 150%;
  padding-block: 2px;
}

.searchRow-other p{
  font-size: 0.8em;
}
.searchRow-xref ul{
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.obsolete{
  color: red;
}

/* New CSS for better wrapping and responsiveness */
.facet-container {
  padding: 0;
}

.facet-container h5 {
  margin-bottom: 1em;
}

.facet-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5em;
}

.facet-item span {
  flex: 1 1;
  text-align: left;
}

.facet-item .badge {
  margin-left: 1em;
}

.facet-indent {
  text-align: right;
  padding-right: 0px;
}
.facet-indent-text {
  font-size: 0.85rem;
}

@keyframes facetToggleFadeIn {
  from {
    opacity: 0;
    transform: translateX(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@media (max-width: 576px) {
  .facet-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .facet-item .badge {
    margin-left: 0;
    margin-top: 0.5em;
  }
}

/*
.Col-right-in {
  background-color: #bbeffd;
  text-align: left;
  color: #282c34;
  padding: 5px 10px;
}
.Col-left-in {
  background-color: #bbeffd;
  text-align: left;
  color: #282c34;
  padding: 5px 10px;
}
*/

.Row-general {
  color: var(--font-black);
}

em {
  background-color: yellow;
  font-style: normal;
}

.highlight-label{
  font-weight: 600;
  border-right: 1px;
  border-right-style: solid;
  padding-right: 0.5em;
  padding-top: 0.15em;
  font-size: 0.8em;
  text-transform: capitalize;
}

.highlight-value{
  padding-top:0.15em;
  padding-left:0.5em;
  font-size:0.8em;
}

.inputGroupRight{
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.inputGroupCenter{
  border-radius:0 !important;
}

.inputGroupLeft{
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
/*
  background-color: #bbeffd;
*/

.dropzone {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  margin: -2px, 2px;
  border-width: 2px;
  border-radius: 2px;
  border-style: dashed;
  background-color: var(--light-blue);
  color: #bdbdbd;
  outline: none;
  transition: border .24s ease-in-out;
}

.sm-table{
  font-size: 0.75rem;
}

.no-pad{
  padding:0px;
  text-align: left;
}



/*
.App-header {
  background-color: var(--font-black);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}
*/
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.6);
  transition: visibility 0s, opacity 0.5s ease;
  opacity: 0;
  visibility: hidden;
}

.ateam-alert {
  margin : 5px;
}

.overlay-on {
  opacity: 1;
  visibility: visible;
}

.custom-filter > * {
  margin: 5px;
}

.custom-filter > div:first-child {
  font-weight: bold;
  text-align: center;
}

.custom-filter > div {
  text-align: left;
}

.custom-filter input {
  margin-right: 10px;
}

.custom-filter label {
  margin-bottom: 0px;
}

/* The search-card action icons (images / TET / PDF) live in a flex rail to the
   right of the card body, not absolutely positioned over it: the card sections
   can be reordered and hidden (SCRUM-6512), so anchoring the icons to a section
   row overlapped the card text. The rail participates in normal layout and can
   never cover text. */
.search-card-body{
  flex: 1 1 auto;
  min-width: 0;
}
.search-card-icons{
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex-shrink: 0;
  padding: 10px 4px 10px 12px;
}
/* On phone-width screens a horizontal rail of up to four buttons (~250px)
   would crowd out the card text: stack the icons vertically instead. */
@media (max-width: 575.98px) {
  .search-card-icons{
    flex-direction: column;
  }
}

.redirect-TET-button{
  width: 65px;
  height: 62px;
}

#TET_icon_id {width: 100%; }
#TET_text_id{font-size: 10px;}

.sort-loading-indicator {
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 1030;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  border: 1px solid var(--light-grey);
  border-radius: 999px;
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.15);
  color: var(--font-black);
  pointer-events: none;
}

.sort-loading-indicator .spinner-border {
  flex-shrink: 0;
}

@media (max-width: 576px) {
  .sort-loading-indicator {
    top: 0.75rem;
    right: 0.75rem;
    padding: 0.45rem 0.65rem;
    font-size: 0.875rem;
  }
}

.wft-bold-header {
  font-weight: bold;
}

.wft-header-bg {
  background-color: #e3f2fd !important;  /* Light blue */
  border-bottom: 1px solid #dee2e6;     /* Add border for better separation */
}

/* Search date facets: Bootstrap's .is-invalid feedback icon sits on the right
   edge, where type="date" already shows the native calendar picker indicator,
   and these inputs live in a narrow sidebar. Drop the icon and its reserved
   padding — the red border is the signal (these are size=sm controls). */
.date-facet-input.form-control.is-invalid {
  background-image: none;
  padding-right: 0.5rem;
}

/* Quick Topic Addition: keep cell content vertically centered. */
.quick-topic-grid .ag-row .ag-cell {
  display: flex;
  align-items: center;
}

/* AG Grid adds an extra wrapper around a cell while its drag handle is shown.
   Keep both wrapped and unwrapped renderers centered so sorting/filtering does
   not shift topic text or assessment controls toward the top of the row. */
.quick-topic-grid .ag-row .ag-cell-wrapper {
  width: 100%;
  align-items: center;
}

/* Workflow editor curation table + Quick Topic Addition: make the row-drag
   handle an obvious, easy grab target (rows only reorder when the handle
   itself is dragged; dragging the row text just selects text because cell
   text selection is enabled). */
.wft-curation-grid .ag-row-drag,
.quick-topic-grid .ag-row-drag {
  cursor: grab;
  padding: 0 10px;
  margin: 0 -4px;
  color: #667085;
}
.wft-curation-grid .ag-row-drag:hover,
.quick-topic-grid .ag-row-drag:hover {
  color: #1570ef;
  background: #eff6ff;
  border-radius: 4px;
}
.wft-curation-grid .ag-row-drag:active,
.quick-topic-grid .ag-row-drag:active {
  cursor: grabbing;
}

/* Alternating row colors */
.ag-theme-quartz .ag-row-striped-dark {
  background-color: #e9ecef;  /* Darker grey */
}

.ag-theme-quartz .ag-row-striped-light {
  background-color: #f8f9fa;  /* Light grey */
}

.number-range-widget {
  margin-top: 30px;
  margin-right: 20px;
}

/* Wider, lighter tooltip for breadcrumb chips (e.g. the active advanced Topic
   query preview). Bootstrap's default .tooltip-inner is narrow (200px) and dark;
   override the inner box and the arrow. Tooltips render in a portal on <body>,
   so this must be global. (SCRUM-6228) */
.breadcrumb-wide-tooltip {
  opacity: 1 !important;
}
.breadcrumb-wide-tooltip .tooltip-inner {
  max-width: 460px;
  background-color: #f6faff;
  color: #212529;
  border: 1px solid #cfe2ff;
  box-shadow: 0 4px 14px rgba(31, 41, 55, 0.18);
  padding: 8px 10px;
  font-size: 0.8rem;
}
/* Bootstrap 4 uses .arrow (not .tooltip-arrow); placement="top" -> top border. */
.breadcrumb-wide-tooltip .arrow::before {
  border-top-color: #cfe2ff;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;;;;;CAMC;;AAED,6BAA6B;AAC7B;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,+BAA+B;EAC/B,uBAAuB;EACvB,2BAA2B;EAC3B,qBAAqB;EACrB,oBAAoB;EACpB,0BAA0B;EAC1B,qBAAqB;AACvB;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,qBAAqB;EACrB,yCAAyC;AAC3C;AACA;EACE,+CAA+C;EAC/C,yBAAyB,IAAI,iBAAiB;EAC9C,uCAAuC;EACvC,oIAAoI;AACtI;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA,4CAA4C;AAC5C;EACE,aAAa;AACf;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,iDAAiD;EACjD,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA,oCAAoC;AACpC;EACE,aAAa;AACf;;AAEA,sCAAsC;AACtC;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;EAChC;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,wEAAwE;AACxE;EACE;;;IAGE,iBAAiB;EACnB;;EAEA;;;IAGE,iBAAiB;EACnB;AACF;;AAEA,0DAA0D;AAC1D;EACE,qDAAqD;EACrD;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,SAAS;IACT,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,iCAAiC;IACjC,uBAAuB;IACvB,aAAa;IACb,gBAAgB;IAChB,aAAa;EACf;;EAEA,0CAA0C;EAC1C;IACE,wBAAwB;EAC1B;;EAEA,qDAAqD;EACrD;IACE,wBAAwB;IACxB,yCAAyC;EAC3C;;EAEA;;;IAGE,iCAAiC;IACjC,sBAAsB;IACtB,oBAAoB;IACpB,yBAAyB;IACzB,0BAA0B;IAC1B,+BAA+B;IAC/B,sCAAsC;EACxC;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,8CAA8C;EAChD;;EAEA;;IAEE,gCAAgC;IAChC,yBAAyB;IACzB,iDAAiD;IACjD,2BAA2B;IAC3B,WAAW;IACX,cAAc;EAChB;;EAEA,iDAAiD;EACjD;IACE,2BAA2B;IAC3B,WAAW;IACX,0CAA0C;IAC1C,YAAY;IACZ,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,oBAAoB;EACtB;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,yDAAkQ;EACpQ;AACF;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,kDAAkD;AAClD;EACE;IACE,yBAAyB;IACzB,6BAA6B;IAC7B,2BAA2B;EAC7B;AACF;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,oBAAoB;EACpB,8BAA8B;EAC9B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,gDAAgD;AAClD;AACA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,8CAA8C;AAChD;;AAEA;;;;;;;;;;CAUC;;AAED;EACE,yCAAyC;EACzC,8CAA8C;AAChD;;AAEA;EACE,wCAAwC;EACxC,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oDAAoD;EACpD,wCAAwC;AAC1C;AACA;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,6BAA6B;EAC7B,wCAAwC;AAC1C;AACA;;;;;;;;;;;;;;;;;;;;;CAqBC;;AAED;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA,mCAAmC;;AAEnC;EACE,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,wDAAwD;AAC1D;AACA;EACE,kDAAkD;AACpD;AACA;EACE,kDAAkD;AACpD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;;;;;;;uEAOuE;AACvE;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,6BAA6B;EAC7B,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;kEAGkE;AAClE;EACE,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,YAAY;AACd;AACA;sHACsH;;AAEtH;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,oBAAoB;EACpB,wBAAwB;EACxB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;;;;CAIC;AACD;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;AACA;EACE,UAAU;AACZ;;AAEA,mDAAmD;AACnD;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;AACF;;AAEA;;;;;;;;;;;;;CAaC;;AAED;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;AACA;;CAEC;;AAED;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC,cAAc;EACd,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;;;AAIA;;;;;;;;;;;;;;;CAeC;AACD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,4CAA4C;EAC5C,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;sBAIsB;AACtB;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,2BAA2B;AAC7B;AACA;uEACuE;AACvE;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,cAAc,WAAW,EAAE;AAC3B,aAAa,eAAe,CAAC;;AAE7B;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,mCAAmC;EACnC,oBAAoB;EACpB,2CAA2C;EAC3C,iDAAiD;EACjD,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,YAAY;IACZ,cAAc;IACd,wBAAwB;IACxB,mBAAmB;EACrB;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oCAAoC,GAAG,eAAe;EACtD,gCAAgC,MAAM,qCAAqC;AAC7E;;AAEA;;;yEAGyE;AACzE;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;2EAE2E;AAC3E;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;;gCAGgC;AAChC;;EAEE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA;;EAEE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;EAEE,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB,GAAG,gBAAgB;AAC9C;;AAEA;EACE,yBAAyB,GAAG,eAAe;AAC7C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;yCAGyC;AACzC;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,6CAA6C;EAC7C,iBAAiB;EACjB,iBAAiB;AACnB;AACA,iFAAiF;AACjF;EACE,yBAAyB;AAC3B","sourcesContent":["/*\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n*/\n\n/*  --medium-blue: #00c9ff; */\n:root {\n  --light-blue: #d9f4ff;\n  --light-blue-hover: #bbeffd;\n  --medium-blue: #0069d9;\n  --nav-blue: #2598c5;\n  --nav-green: #16a085;\n  --nav-cyan: #02bdde;\n  --font-black: #282c34;\n  --updated-purple: #e6deff;\n  --updated-purple-hover: #d5d1ff;\n  --light-yellow: #ffffcc;\n  --light-grey-hover: #ced4da;\n  --light-grey: #e9ecef;\n  --light-red: #ffebeb;\n  --light-red-hover: #ffcccb;\n  --medium-red: #ff0500;\n}\n\n\n.App {\n  text-align: center;\n}\n\n.App-testing-prod {\n  /* background color for prod when testing */\n  background-color: red;\n  /* background-color: #ffcccb; light red */\n}\n.App-testing-dev {\n  /* background color for not-prod when testing */\n  background-color: #f7f6af;   /* light yellow */\n  /* background-color: #fdf88d;  yellow */\n  /* background: repeating-linear-gradient(-45deg, #fdf88d, #fdf88d 10px, #e9e485 10px, #e9e485 20px);  diagonal yellow dark warning */\n}\n\n.Alliance-logo {\n  height: 50px;\n  pointer-events: none;\n}\n\n.Navbar {\n  background-color: var(--nav-blue);\n  color: white;\n}\n\n.Navbar-stage {\n  background-color: var(--nav-green);\n  color: white;\n}\n\n.Navbar-dev {\n  background-color: var(--nav-cyan);\n  color: white;\n}\n\n/* Custom navbar expand behavior at 1400px */\n.navbar-custom-expand .navbar-toggler {\n  display: flex;\n}\n\n/* Close button row for mobile sidebar */\n.navbar-close-row {\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.3);\n  margin-bottom: 0.5rem;\n}\n\n.navbar-close-btn {\n  background: none;\n  border: none;\n  color: white;\n  font-size: 1.25rem;\n  cursor: pointer;\n  padding: 0.5rem;\n  margin-right: 0.5rem;\n}\n\n.navbar-close-btn:hover {\n  opacity: 0.7;\n}\n\n/* Mobile only elements (< 1400px) */\n.navbar-mobile-only {\n  display: flex;\n}\n\n/* Desktop only elements (>= 1400px) */\n.navbar-desktop-only {\n  display: none;\n}\n\n@media (min-width: 1400px) {\n  .navbar-custom-expand .navbar-toggler {\n    display: none;\n  }\n\n  .navbar-custom-expand .navbar-collapse {\n    display: flex !important;\n    flex-direction: row !important;\n  }\n\n  .navbar-custom-expand .navbar-main-links,\n  .navbar-custom-expand .navbar-right-links {\n    flex-direction: row !important;\n  }\n\n  .navbar-mobile-only {\n    display: none !important;\n  }\n\n  .navbar-desktop-only {\n    display: block !important;\n  }\n}\n\n/* Prevent navbar from wrapping - keep items in one row (desktop only) */\n@media (min-width: 1400px) {\n  .Navbar .navbar-collapse,\n  .Navbar-stage .navbar-collapse,\n  .Navbar-dev .navbar-collapse {\n    flex-wrap: nowrap;\n  }\n\n  .Navbar .navbar-collapse .nav,\n  .Navbar-stage .navbar-collapse .nav,\n  .Navbar-dev .navbar-collapse .nav {\n    flex-wrap: nowrap;\n  }\n}\n\n/* Sidebar style for collapsed navbar on smaller screens */\n@media (max-width: 1399.98px) {\n  /* Base styles for the collapse - hidden by default */\n  .navbar-custom-expand .navbar-collapse {\n    position: fixed;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    width: 280px;\n    max-width: 80vw;\n    background-color: inherit;\n    flex-direction: column !important;\n    align-items: flex-start;\n    padding: 1rem;\n    overflow-y: auto;\n    z-index: 1050;\n  }\n\n  /* When collapsed (not showing), hide it */\n  .navbar-custom-expand .navbar-collapse:not(.show) {\n    display: none !important;\n  }\n\n  /* When expanded (showing), display as flex sidebar */\n  .navbar-custom-expand .navbar-collapse.show {\n    display: flex !important;\n    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.3);\n  }\n\n  .navbar-custom-expand .navbar-collapse .nav,\n  .navbar-custom-expand .navbar-main-links,\n  .navbar-custom-expand .navbar-right-links {\n    flex-direction: column !important;\n    width: 100% !important;\n    margin: 0 !important;\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n    align-items: stretch !important;\n    justify-content: flex-start !important;\n  }\n\n  .navbar-custom-expand .navbar-collapse .nav.mx-auto {\n    margin: 0 !important;\n  }\n\n  .navbar-custom-expand .navbar-right-links {\n    margin-top: 0.5rem;\n    padding-top: 0.5rem;\n    border-top: 1px solid rgba(255, 255, 255, 0.3);\n  }\n\n  .navbar-custom-expand .navbar-collapse .nav-link,\n  .navbar-custom-expand .navbar-collapse .navbar_link {\n    padding: 0.75rem 1rem !important;\n    margin-left: 0 !important;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n    text-align: left !important;\n    width: 100%;\n    display: block;\n  }\n\n  /* Ensure dropdown menus are visible in sidebar */\n  .navbar-custom-expand .navbar-collapse .dropdown-menu {\n    position: static !important;\n    float: none;\n    background-color: rgba(255, 255, 255, 0.1);\n    border: none;\n    margin: 0;\n    padding: 0;\n  }\n\n  .navbar-custom-expand .navbar-collapse .dropdown-item {\n    color: white;\n    padding: 0.5rem 1rem;\n  }\n\n  .navbar-custom-expand .navbar-collapse .dropdown-item:hover {\n    background-color: rgba(255, 255, 255, 0.2);\n  }\n\n  .navbar-custom-expand .navbar-toggler {\n    border-color: rgba(255, 255, 255, 0.5);\n  }\n\n  .navbar-custom-expand .navbar-toggler-icon {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.9%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n  }\n}\n\n#login-nav-dropdown {\n  font-family: 'Roboto', sans-serif;\n  color: white !important;\n  margin-left: 20px;\n}\n\n#tester-nav-dropdown {\n  font-family: 'Roboto', sans-serif;\n  color: white !important;\n  margin-left: 20px;\n}\n\n#devtools-nav-dropdown {\n  font-family: 'Roboto', sans-serif;\n  color: white !important;\n  margin-left: 20px;\n}\n\n.navbar_link {\n  font-family: 'Roboto', sans-serif;\n  color: white !important;\n  margin-left: 20px;\n}\n\n/* Override navbar_link margin on mobile sidebar */\n@media (max-width: 1399.98px) {\n  .navbar_link {\n    margin-left: 0 !important;\n    padding-left: 1rem !important;\n    text-align: left !important;\n  }\n}\n\n.NotLoggedInAlert-everLogged {\n  position: sticky !important;\n  top: 0 !important;\n  left: 0px;\n  width: 100%;\n  z-index: 998;\n  margin-bottom: 0 !important;\n}\n\n.button-to-link {\n  background: none!important;\n  border: none;\n  padding: 0!important;\n  font-family: arial, sans-serif;\n  color: #007bff;\n  cursor: pointer;\n}\n\n.button-to-link:hover {\n  color: #069;\n  text-decoration: underline;\n}\n\n.affiliation {\n  font-size: 14px;\n  color: grey;\n}\n\n.row-even {\n  padding-bottom: 1rem;\n  margin-bottom: 0 !important;\n  background-color: var(--light-yellow) !important;\n}\n.row-odd {\n  padding-bottom: 1rem;\n  margin-bottom: 0 !important;\n  background-color: white !important;\n}\n\n.div-grey-border {\n  border: 1px solid var(--light-grey-hover);\n  border-radius: .25rem;\n  min-height: 2.3rem;\n  padding: .35rem;\n}\n\n.div-merge {\n  border-radius: .25rem;\n  overflow: hidden;\n  padding: .35rem;\n  margin: .35rem;\n}\n\n.div-merge-grey {\n  border: 1px solid var(--light-grey-hover);\n  background-color: var(--light-grey) !important;\n}\n\n/*\n.div-merge-stripes {\n  background: repeating-linear-gradient(\n    45deg,\n    transparent,\n    transparent 10px,\n    var(--light-grey) 10px,\n    var(--light-grey) 20px\n  );\n}\n*/\n\n.div-merge-keep {\n  border: 1px solid var(--light-blue-hover);\n  background-color: var(--light-blue) !important;\n}\n\n.div-merge-obsolete {\n  border: 1px solid var(--light-red-hover);\n  background-color: var(--light-red) !important;\n}\n\n.span-merge-header-success {\n  font-size: 1.2em;\n  color: var(--medium-blue) !important;\n}\n\n.span-merge-header-failure {\n  font-size: 1.2em;\n  color: var(--medium-red) !important;\n}\n\n.span-merge-message-init {\n  color: 'black';\n}\n\n.span-merge-message-success {\n  color: var(--medium-blue) !important;\n}\n\n.span-merge-message-failure {\n  color: var(--medium-red) !important;\n}\n\n.biblio-updating {\n  text-align: center;\n  background-color: var(--light-grey) !important;\n}\n\n.sort-status-alert {\n  margin-bottom: 0;\n}\n\n.biblio-button:hover {\n  background-color: var(--light-blue-hover) !important;\n  filter: drop-shadow(2px 2px 1px #aaaaaa);\n}\n.biblio-button {\n  text-align: center;\n  background-color: var(--light-blue) !important;\n  border-radius: 5px !important;\n  filter: drop-shadow(3px 3px 1px #aaaaaa);\n}\n/*\n  background-color: #ffffba !important;\n  font-weight: 600 !important;\n  font-weight: bold !important;\n  border-color: white !important;\n  box-shadow:\n    0 0 0 3px white,\n    0 0 0 8px #ffffba;\n  border-color: #2598c5 !important;\n  background-color: var(--light-grey) !important;\n  display: block;\n  width: 100%;\n  padding-left: .75rem;\n  padding-right: .75rem;\n  color: #282c34;\n  line-height: 1.5;\n  border: 1px solid #2598c5;\n  border-radius: .25rem;\n  height: calc(1.5em + .75rem + 2px);\n  padding-top: .375rem;\n  padding-bottom: .375rem;\n*/\n\n.task {\n  background: #f4f4f4;\n  margin: 5px;\n  padding: 10px 20px;\n  cursor: pointer;\n  padding-left: 40px;\n}\n\n/*  border-radius: 30px 0 0 30px; */\n\n.task.reminder {\n  border-left: 5px solid green;\n}\n\n.Col-display {\n  background-color: var(--light-blue);\n}\n\n.Col-display-warn {\n  background-color: var(--light-red);\n}\n\n.Col-display-grey {\n  background-color: var(--light-grey);\n}\n\n.updated-biblio-button:hover {\n  background-color: var(--updated-purple-hover) !important;\n}\n.updated-biblio-button {\n  background-color: var(--updated-purple) !important;\n}\n.updated {\n  background-color: var(--updated-purple) !important;\n}\n\n.underlined {\n  border-bottom: 4px solid var(--light-blue-hover);\n}\n\n.radio-form {\n  margin: 4px 4px 4px 4px;\n  padding: 2px 2px 4px 2px;\n}\n.radio-span {\n  display: inline-block;\n  margin: 4px 4px 4px 4px;\n  padding: 2px 0px 4px 2px;\n}\n\n/* Mode-selector row: use the full viewport width so all options sit on one\n   line on wide monitors (wrapping only when genuinely narrow), instead of\n   being capped by the Bootstrap container and wrapping early. Full-bleed via\n   negative margins keeps it centered without a hard-coded width.\n   100vw includes the vertical scrollbar's width while the containing block\n   does not, so on classic (non-overlay) scrollbars the full-bleed row is\n   ~15px wider than the viewport; the body-level overflow-x: clip below\n   swallows that instead of growing a page-wide horizontal scrollbar. */\n.biblio-mode-radios {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  width: auto;\n  margin-left: calc(50% - 50vw);\n  margin-right: calc(50% - 50vw);\n  padding-left: 12px;\n  padding-right: 12px;\n}\n\n/* Clip (not hide) page-level horizontal overflow: every horizontally wide\n   element in this app scrolls inside its own container, so overflow past the\n   body is only ever the 100vw-vs-scrollbar artifact above. `clip` does not\n   create a scroll container, so position: sticky keeps working. */\nbody {\n  overflow-x: clip;\n}\n\n.radio-span:hover {\n  background-color: var(--light-blue);\n  border-radius: 10px;\n  opacity: 0.9;\n}\n/* opacity: 90%;  proper react build production does not like this\n   https://stackoverflow.com/questions/58853844/the-opacity-value-was-changed-to-1-after-building-the-reacjs-project */\n\n.Col-editor-disabled {\n  background-color: #e9ecef;\n}\n\n.Col-checkbox {\n  display: flex;\n  align-items : center;\n  padding: 0 !important;\n}\n\n.ColEditorCheckbox input {\n  height: 20px;\n  width: 20px;\n}\n\n.Col-editor-buttons {\n  display: flex;\n}\n\n.Col-general {\n  text-align: left;\n  display: flex;\n  align-items : center;\n  color: var(--font-black);\n  border: 2px solid white;\n  padding: 5px 10px;\n}\n/*\n  background-color: #f4f4f4;\n  border: 1px solid #bbbbbb;\n  border: 1px solid #61dafb;\n*/\n.Col-display-right {\n  border-radius: 0 30px 30px 0;\n}\n.Col-display-left {\n  border-radius: 30px 0 0 30px;\n}\n.Col-search {\n  display: block;\n}\n.searchRow-title{\n  font-size: 1.4em;\n}\n.searchRow-xref{\n  padding-block: 10px;\n}\n.searchRow-other{\n  line-height: 150%;\n  padding-block: 2px;\n}\n\n.searchRow-other p{\n  font-size: 0.8em;\n}\n.searchRow-xref ul{\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n.obsolete{\n  color: red;\n}\n\n/* New CSS for better wrapping and responsiveness */\n.facet-container {\n  padding: 0;\n}\n\n.facet-container h5 {\n  margin-bottom: 1em;\n}\n\n.facet-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0.5em;\n}\n\n.facet-item span {\n  flex: 1;\n  text-align: left;\n}\n\n.facet-item .badge {\n  margin-left: 1em;\n}\n\n.facet-indent {\n  text-align: right;\n  padding-right: 0px;\n}\n.facet-indent-text {\n  font-size: 0.85rem;\n}\n\n@keyframes facetToggleFadeIn {\n  from {\n    opacity: 0;\n    transform: translateX(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@media (max-width: 576px) {\n  .facet-item {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .facet-item .badge {\n    margin-left: 0;\n    margin-top: 0.5em;\n  }\n}\n\n/*\n.Col-right-in {\n  background-color: #bbeffd;\n  text-align: left;\n  color: #282c34;\n  padding: 5px 10px;\n}\n.Col-left-in {\n  background-color: #bbeffd;\n  text-align: left;\n  color: #282c34;\n  padding: 5px 10px;\n}\n*/\n\n.Row-general {\n  color: var(--font-black);\n}\n\nem {\n  background-color: yellow;\n  font-style: normal;\n}\n\n.highlight-label{\n  font-weight: 600;\n  border-right: 1px;\n  border-right-style: solid;\n  padding-right: 0.5em;\n  padding-top: 0.15em;\n  font-size: 0.8em;\n  text-transform: capitalize;\n}\n\n.highlight-value{\n  padding-top:0.15em;\n  padding-left:0.5em;\n  font-size:0.8em;\n}\n\n.inputGroupRight{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n\n.inputGroupCenter{\n  border-radius:0 !important;\n}\n\n.inputGroupLeft{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n/*\n  background-color: #bbeffd;\n*/\n\n.dropzone {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px;\n  margin: -2px, 2px;\n  border-width: 2px;\n  border-radius: 2px;\n  border-style: dashed;\n  background-color: var(--light-blue);\n  color: #bdbdbd;\n  outline: none;\n  transition: border .24s ease-in-out;\n}\n\n.sm-table{\n  font-size: 0.75rem;\n}\n\n.no-pad{\n  padding:0px;\n  text-align: left;\n}\n\n\n\n/*\n.App-header {\n  background-color: var(--font-black);\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n*/\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  z-index: 10;\n  background-color: rgba(0, 0, 0, 0.6);\n  transition: visibility 0s, opacity 0.5s ease;\n  opacity: 0;\n  visibility: hidden;\n}\n\n.ateam-alert {\n  margin : 5px;\n}\n\n.overlay-on {\n  opacity: 1;\n  visibility: visible;\n}\n\n.custom-filter > * {\n  margin: 5px;\n}\n\n.custom-filter > div:first-child {\n  font-weight: bold;\n  text-align: center;\n}\n\n.custom-filter > div {\n  text-align: left;\n}\n\n.custom-filter input {\n  margin-right: 10px;\n}\n\n.custom-filter label {\n  margin-bottom: 0px;\n}\n\n/* The search-card action icons (images / TET / PDF) live in a flex rail to the\n   right of the card body, not absolutely positioned over it: the card sections\n   can be reordered and hidden (SCRUM-6512), so anchoring the icons to a section\n   row overlapped the card text. The rail participates in normal layout and can\n   never cover text. */\n.search-card-body{\n  flex: 1 1 auto;\n  min-width: 0;\n}\n.search-card-icons{\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  flex-shrink: 0;\n  padding: 10px 4px 10px 12px;\n}\n/* On phone-width screens a horizontal rail of up to four buttons (~250px)\n   would crowd out the card text: stack the icons vertically instead. */\n@media (max-width: 575.98px) {\n  .search-card-icons{\n    flex-direction: column;\n  }\n}\n\n.redirect-TET-button{\n  width: 65px;\n  height: 62px;\n}\n\n#TET_icon_id {width: 100%; }\n#TET_text_id{font-size: 10px;}\n\n.sort-loading-indicator {\n  position: fixed;\n  top: 1rem;\n  right: 1rem;\n  z-index: 1030;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 0.75rem;\n  border: 1px solid var(--light-grey);\n  border-radius: 999px;\n  background-color: rgba(255, 255, 255, 0.95);\n  box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.15);\n  color: var(--font-black);\n  pointer-events: none;\n}\n\n.sort-loading-indicator .spinner-border {\n  flex-shrink: 0;\n}\n\n@media (max-width: 576px) {\n  .sort-loading-indicator {\n    top: 0.75rem;\n    right: 0.75rem;\n    padding: 0.45rem 0.65rem;\n    font-size: 0.875rem;\n  }\n}\n\n.wft-bold-header {\n  font-weight: bold;\n}\n\n.wft-header-bg {\n  background-color: #e3f2fd !important;  /* Light blue */\n  border-bottom: 1px solid #dee2e6;     /* Add border for better separation */\n}\n\n/* Search date facets: Bootstrap's .is-invalid feedback icon sits on the right\n   edge, where type=\"date\" already shows the native calendar picker indicator,\n   and these inputs live in a narrow sidebar. Drop the icon and its reserved\n   padding — the red border is the signal (these are size=sm controls). */\n.date-facet-input.form-control.is-invalid {\n  background-image: none;\n  padding-right: 0.5rem;\n}\n\n/* Quick Topic Addition: keep cell content vertically centered. */\n.quick-topic-grid .ag-row .ag-cell {\n  display: flex;\n  align-items: center;\n}\n\n/* AG Grid adds an extra wrapper around a cell while its drag handle is shown.\n   Keep both wrapped and unwrapped renderers centered so sorting/filtering does\n   not shift topic text or assessment controls toward the top of the row. */\n.quick-topic-grid .ag-row .ag-cell-wrapper {\n  width: 100%;\n  align-items: center;\n}\n\n/* Workflow editor curation table + Quick Topic Addition: make the row-drag\n   handle an obvious, easy grab target (rows only reorder when the handle\n   itself is dragged; dragging the row text just selects text because cell\n   text selection is enabled). */\n.wft-curation-grid .ag-row-drag,\n.quick-topic-grid .ag-row-drag {\n  cursor: grab;\n  padding: 0 10px;\n  margin: 0 -4px;\n  color: #667085;\n}\n.wft-curation-grid .ag-row-drag:hover,\n.quick-topic-grid .ag-row-drag:hover {\n  color: #1570ef;\n  background: #eff6ff;\n  border-radius: 4px;\n}\n.wft-curation-grid .ag-row-drag:active,\n.quick-topic-grid .ag-row-drag:active {\n  cursor: grabbing;\n}\n\n/* Alternating row colors */\n.ag-theme-quartz .ag-row-striped-dark {\n  background-color: #e9ecef;  /* Darker grey */\n}\n\n.ag-theme-quartz .ag-row-striped-light {\n  background-color: #f8f9fa;  /* Light grey */\n}\n\n.number-range-widget {\n  margin-top: 30px;\n  margin-right: 20px;\n}\n\n/* Wider, lighter tooltip for breadcrumb chips (e.g. the active advanced Topic\n   query preview). Bootstrap's default .tooltip-inner is narrow (200px) and dark;\n   override the inner box and the arrow. Tooltips render in a portal on <body>,\n   so this must be global. (SCRUM-6228) */\n.breadcrumb-wide-tooltip {\n  opacity: 1 !important;\n}\n.breadcrumb-wide-tooltip .tooltip-inner {\n  max-width: 460px;\n  background-color: #f6faff;\n  color: #212529;\n  border: 1px solid #cfe2ff;\n  box-shadow: 0 4px 14px rgba(31, 41, 55, 0.18);\n  padding: 8px 10px;\n  font-size: 0.8rem;\n}\n/* Bootstrap 4 uses .arrow (not .tooltip-arrow); placement=\"top\" -> top border. */\n.breadcrumb-wide-tooltip .arrow::before {\n  border-top-color: #cfe2ff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
